import axios from "axios";

//const API_URL = "http://192.168.55.192:8080/v1/"; //mac

//const API_URL = "http://192.168.55.194:8080/v1/"; PC

const API_URL = "https://api.jazzysign.com/v1/";

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default instance;